<template>
	<section class="benefits">
		<article class="benefits__content container">
			<div class="content-section__first">
				<div class="--fade-in-right" data-vertical-ivp-class="--animate">
					<h2 class="benefits__title">Benefits of the SmartGreen Home System Include:</h2>
					<hr>
					<ul class="benefits-list">
						<li>Making a real planet changing difference in reducing air pollution</li>
						<li>Eliminate or significantly reducing homeowners’ future utility bills</li>
						<li>Lifetime energy independence, protection from price escalation and energy shortages</li>
						<li>Eliminating Greenhouse Gas emissions from operation of home and daily life</li>
						<li>Increased home value</li>
						<li>Integrated design for seamless operation of renewable energy systems</li>
						<li>Significantly healthier living environment</li>
						<li>Leveraging existing renewable energy tax credits and electrification incentives</li>
						<li>Creating stable jobs capable of supporting families in the decarbonized future</li>
					</ul>
				</div>
				<div class="content-section__second --fade-in-left" data-vertical-ivp-class="--animate">
					<iframe class="video" width="400" height="300" src="https://www.youtube.com/embed/u-Yq-_7GolY?enablejsapi=1&origin=https:%2F%2Fwww.manhattanstreetcapital.com"></iframe>
				</div>
			</div>
			<CTA />
		</article>
	</section>
</template>

<script>
import CTA from '../components/cta.vue';

export default {
  name: 'Benefits',
  components: {
	CTA
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/benefits.scss";
</style>
